import {
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input
} from '@angular/core';

@Directive({
  selector: '[bsNoImageFound]',
  exportAs: 'bsNoImageFound',
})
export class NoImageFoundDirective {
  @Input() bsNoImageFound!: string;
  hasError = false;
  readonly NO_IMAGE =
    'https://www.freeiconspng.com/thumbs/no-image-icon/no-image-icon-15.png';
  constructor(private element: ElementRef) {}

  @HostBinding('class.error') get error() {
    return this.hasError;
  }

  @HostListener('error')
  updateUrl() {
    this.hasError = true;
    this.element.nativeElement.attributes['src'].value =
      this.bsNoImageFound ?? this.NO_IMAGE;
  }
}
